export const TEST_IDS = {
  optionAddedDate: 'option-added-date',
  optionDeclinedReason: 'option-card-declined-reason',
  optionStatusDot: 'option-status-dot',
  optionSource: 'option-card-source',
  optionSourceSegment: 'option-card-source-segment',
  optionApproval: 'option-card-approval',
  optionApprovalDate: 'option-card-approval-date',
}
